<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>
<div class="container-fluid p-5">
  <h3>Gestión de Tipo de Gastos</h3>
  <div class="btn btn-primary my-2" (click)="agregar()"><i class="fas fa-plus-circle me-2"></i>Registrar Nuevo Tipo
    Gasto</div>
  <kuv-lazy-table [url]="config.apiUrl + 'tipo-gastos/index'" [urlExcel]="config.apiUrl + 'tipo-gastos/excel'"
    [headersBlob]="sesion.headersBlob" [columnas]="columnas" [acciones]="acciones" [reloadEmitter]="reloadEmitter"
    [hasShadow]="true" [headers]="sesion.headers" [filtros]="filtros" [isRounded]="true">
  </kuv-lazy-table>
</div>